import { defaultLocale, ServiceRegistryLocale } from './types';

export const normalizeLocale = (
  value?: string | null,
): ServiceRegistryLocale => {
  const language = value?.trim().replace('_', '-').split('-')[0].toLowerCase();
  if (language === 'fr') return 'fr-CA';
  if (language === 'en') return 'en-CA';
  return defaultLocale;
};

export const toSolaceLanguage = (locale: ServiceRegistryLocale): 'en' | 'fr' =>
  locale === 'fr-CA' ? 'fr' : 'en';
